module.exports = __webpack_public_path__ + "static/media/REVERSI-1.2b18d84f.png";